function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.75C18.7132 0.75 23.75 5.7868 23.75 12C23.75 18.2132 18.7132 23.25 12.5 23.25C6.2868 23.25 1.25 18.2132 1.25 12C1.25 5.7868 6.2868 0.75 12.5 0.75Z",
    stroke: "#EAECF0",
    style: {
      stroke: "#EAECF0",
      stroke: "color(display-p3 0.9176 0.9255 0.9412)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 4,
    fill: "#D0D5DD",
    style: {
      fill: "#D0D5DD",
      fill: "color(display-p3 0.8157 0.8353 0.8667)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon);
export default __webpack_public_path__ + "static/media/step-icon.4be043fb14d48b92e13c5687ae37d08f.svg";
export { ForwardRef as ReactComponent };